import type {State} from 'src/reducers';
import type {Contact, ContactMap} from 'src/types/contacts';

import {createSelector} from 'reselect';

import {captureSentryMessage} from 'src/utils/sentry';


const useParam = (state: State, param: string) => param;

export const getContacts = (state: State): ContactMap =>
  state.contacts.contacts;
export const selectContactsAsArray: (arg1: State) => Contact[] = createSelector(
  getContacts,
  (contacts) => Object.values(contacts),
);

export const selectContact = (
  state: State,
  contactId: string,
): Contact | null | undefined => state.contacts.contacts[contactId];

export const getContactByPhone = (
  contacts: Contact[],
  phone: string,
): Contact | null | undefined =>
  contacts.find((contact) => {
    checkForContactPhoneError(contact);
    return contact.phoneNumbers.some(({value}) => value === phone);
  });

export const selectContactByPhone: (
  arg1: State,
  arg2: string,
) => Contact | null | undefined = createSelector(
  selectContactsAsArray,
  useParam,
  getContactByPhone,
);

// TODO (kyle): remove this later. it's temporary.
// @ts-expect-error - TS7006 - Parameter 'contact' implicitly has an 'any' type.
function checkForContactPhoneError(contact) {
  if (!contact.phoneNumbers) {
    captureSentryMessage('Contact is missing `phoneNumbers`', {
      level: 'error',
      extra: {
        contact,
      },
    });

    // NOTE (kyle): we intentionally mutate the contact here to avoid
    // duplicating this error.
    contact.phoneNumbers = [];
  }
}
